// NOVAPAY-116-RC3-R1 — customer-visible legal revision copy (not internal registry IDs).
export const CUSTOMER_LEGAL_REVISION_UA = "Редакція від 17.08.2026";
export const CUSTOMER_LEGAL_REVISION_EN = "Revision dated 17 August 2026";

export function customerLegalRevisionLabel(lang: "ua" | "en"): string {
  return lang === "en" ? CUSTOMER_LEGAL_REVISION_EN : CUSTOMER_LEGAL_REVISION_UA;
}
